import "./Title.css";

type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface TitleProps {
  text: string;
  as?: HeadingLevel;
  className?: string;
}

export const Title = ({ text, as: Heading = "h3", className }: TitleProps) => {
  return <Heading className={["gradient-title", className].filter(Boolean).join(" ")}>{text}</Heading>;
};
